import SendMapper from './SendMapper';
import ReceivedMapper from './ReceivedMapper';
import ViewrMapper from './ViewrMapper';
import { isEmpty } from '../../utils/ValidForm';

export default class Mapper {
    #send;
    #received;
    #viewr;
    #options;
    constructor() {
        this.#send = new SendMapper(this);
        this.#received = new ReceivedMapper(this);
        this.#viewr = new ViewrMapper(this);
    }

    static setNullInEmpty(obj) {
        let convert = false;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
            convert = true;
        }
        const keys = Object.keys(obj);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];

            obj[key] =
                isEmpty(obj[key]) || (Array.isArray(obj[key]) && obj[key].length === 0)
                    ? null
                    : obj[key];
        }
        if (convert) {
            obj = JSON.stringify(obj);
        }
        return obj;
    }

    static setEmptyInNull(obj) {
        if (!Array.isArray(obj)) {
            Object.keys(obj).forEach((key) => {
                obj[key] = obj[key] === null ? '' : obj[key];
            });
        }
        return obj;
    }

    getOptions() {
        return this.#options;
    }

    setOptions(options) {
        this.#options = options;
    }

    formatToInput(data, formController) {
        return this.#received.prepare(data, formController);
    }

    formatToView(dados, config) {
        return this.#viewr.prepare(dados, config);
    }

    formatToSend(formController, registro, params) {
        return this.#send.prepare(formController, registro, params);
    }
}
